function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLogin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2453",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.057,
    height: 25,
    viewBox: "0 0 22.057 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bhl9h5yrsa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5660",
    style: {
      fill: "none"
    },
    d: "M0 0h22.057v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2452",
    style: {
      clipPath: "url(#bhl9h5yrsa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3872",
    d: "M35.9 25c-1.789 0-3.369 0-4.831-.009a3.763 3.763 0 0 1-3.636-3.278 18.664 18.664 0 0 1-.057-2.878v-.026l.018-.609a.891.891 0 0 1 .883-.857h.046a.966.966 0 0 1 .909.811 2.825 2.825 0 0 1 .028.612v2.422a1.921 1.921 0 0 0 1.973 1.963h10.878a1.935 1.935 0 0 0 2.013-2.066V3.955a1.955 1.955 0 0 0-2.1-2.1h-5.856c-1.947 0-3.437-.005-4.832-.016h-.016a2.165 2.165 0 0 0-1.547.664 1.911 1.911 0 0 0-.522 1.456c.032.569.022 1.156.012 1.723 0 .17-.006.338-.008.506a.991.991 0 0 1-.438.916 1.012 1.012 0 0 1-.538.16.863.863 0 0 1-.875-.846L27.4 6.2a13.3 13.3 0 0 1 .086-3.171 3.741 3.741 0 0 1 3.59-3.02C33.186 0 35.094 0 36.9 0c1.924 0 3.7 0 5.419.013A3.738 3.738 0 0 1 45.972 3.7c.005 1.991 0 4.016 0 5.975V21.116a3.7 3.7 0 0 1-1.99 3.425 3.272 3.272 0 0 1-1.662.452h-1.234Q38.495 25 35.9 25",
    transform: "translate(-23.919)",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3873",
    d: "M11.335 68.517a.9.9 0 0 1-.655-.3.873.873 0 0 1 .028-1.3c.48-.486.954-.956 1.457-1.454l.934-.928-.327-.211a.708.708 0 0 0-.4-.113H1.004a1.011 1.011 0 0 1-.846-.4.919.919 0 0 1-.1-.858.894.894 0 0 1 .865-.59h11.834l.217-.464-.608-.594q-.452-.441-.9-.884c-.27-.266-.5-.488-.722-.724a.939.939 0 0 1 .587-1.636.976.976 0 0 1 .679.31c1.5 1.468 2.875 2.835 4.206 4.178a.98.98 0 0 1-.061 1.543q-1.348 1.349-2.7 2.692l-1.082 1.076-.1.1c-.1.1-.181.182-.27.264a.987.987 0 0 1-.669.284",
    transform: "translate(0 -50.796)",
    style: {
      fill: "#1a1818"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLogin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-login.046d03ba03ebc71b4451339f13a0033c.svg";